export default {
    
    // Brand and tagline
    "sri_astro_veda": "सूर्या मीडिया",
    "footer_tagline": "ज्योतिष और वास्तु। आधुनिक, व्यक्तिगत, विश्वसनीय।",

    // Navigation
    "navigation": "नेविगेशन",
    "home": "होम",
    "about": "हमारे बारे में",
    "contact": "संपर्क करें", 
    "get_reading": "पढ़ाई प्राप्त करें",

    // Core Services
    "core_services_footer": "मुख्य सेवाएँ",
    "birth_chart_footer": "जन्म कुंडली",
    "match_kundli_footer": "कुंडली मिलान",
    "ascendant_footer": "लग्न",
    "dasha_analysis_footer": "दशा विश्लेषण",
    "nakshatra_footer": "नक्षत्र",
    "numerology_footer": "अंक ज्योतिष",

    // Predictions
    "predictions_footer": "भविष्यवाणियाँ",
    "life_predictions_footer": "जीवन भविष्यवाणी",
    "2025_report_footer": "2025 रिपोर्ट",
    "daily_horoscope_footer": "दैनिक राशिफल",
    "love_report_footer": "प्रेम रिपोर्ट",
    "career_report_footer": "करियर रिपोर्ट",
    "health_report_footer": "स्वास्थ्य रिपोर्ट",

    // Remedies
    "remedies_footer": "उपाय",
    "lal_kitab_footer": "लाल किताब",
    "mangal_dosha_footer": "मंगल दोष",
    "kalsarp_dosh_footer": "कालसर्प दोष",
    "sade_sati_footer": "साढ़े साती",
    "ask_question_footer": "प्रश्न पूछें",
    "gemstones_footer": "रत्न",

    // Support
    "support": "सहायता",
    "whatsapp_support": "व्हाट्सएप सहायता",
    "available_24_7": "चैट सहायता",

    // Footer bottom
    "all_rights_reserved": "सभी अधिकार सुरक्षित",
    "made_with": "बनाया गया",
    "in_india": "भारत में",
    "privacy_policy": "गोपनीयता नीति",
    "terms_of_service": "सेवा की शर्तें",
    "disclaimer": "अस्वीकरण",
    "cancellation_policy": "रद्दीकरण नीति",
    "shipping_policy": "शिपिंग नीति"
}
